export default __webpack_public_path__ + "static/media/kitchen5-beforeB-480w.c6b4c7f4.webp";